<template>
    <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text ma-1">
                <v-icon>fas fa-ellipsis-v</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item @click="printCashRegister({ cashRegisterId: item.id, isWithPrinter : false })">
                <v-list-item-title>
                    <v-icon x-small class="mr-2">fas fa-print</v-icon> Imprimir caja
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="printCashRegister({ cashRegisterId: item.id, isWithPrinter : true })">
                <v-list-item-title>
                    <v-icon x-small class="mr-2">fa-solid fa-ticket</v-icon> Imprimir caja en ticket
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openCashRegisterClosed({ cashRegisterId: item.id })" v-if="item.status === 'CLOSED' && isAdmin">
                <v-list-item-title>
                    <v-icon x-small class="mr-2">fa-solid fa-unlock</v-icon> Abrir caja cerrada
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="closeCashRegister({ cashRegisterId: item.id })"
            v-if="item.status === 'OPENED' && (isAdmin || item.userId === currentUser?.id)">
                <v-list-item-title>
                    <v-icon x-small class="mr-2">fa-solid fa-lock</v-icon> Cerrar caja
                </v-list-item-title>
            </v-list-item>
        </v-list>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob"
        :title-pdf="titlePdf" :handlePdfModal="handlePdfModal"
        :dialog="showPdf" v-if="showPdf" />
    </v-menu>
</template>
<script>
import CashRegisterDataService from '@/service/cashRegister/CashRegisterDataService';
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import UsuarioDataService from '@/service/usuario/UsuarioDataService';

export default {
    name: "ActionsCashRegister",
    props:{
        item: { type: Object },
        initTableCashRegister: { type: Function },
        currentUser: { type: Object },
    },
    components: {
        PreviewPDF
    },
    data() {
        return {
            pdfBlob: '',
            pdfSource: null,
            showPdf: false,
            lstSale: [],
            titlePdf: 'Caja'
        }
    },
    methods: {
        printCashRegister({ cashRegisterId, isWithPrinter = false }){
            const params = { isWithPrinter };
            CashRegisterDataService.printCashRegister(cashRegisterId, params).then( response => {
                this.titlePdf = isWithPrinter ? 'Caja con formato de ticket' : 'Caja';
                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                this.pdfSource = URL.createObjectURL(this.pdfBlob)
                this.showPdf = true
            }).catch( error => {
                this.$swal.fire({ title: 'Error', text: 'No se pudo procesar la petición, ' +error, icon: 'error', showConfirmButton: false, timer: 2000 })
            });
        },
        openCashRegisterClosed({ cashRegisterId }){
            this.$swal.fire({
                title: 'Estas seguro de abrir la caja?',
                text: "Esta es una cuenta de caja cerrada!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No, cancelar!',
                confirmButtonText: 'Si, abrir!'
            }).then( result => {
                if(!result.isConfirmed) return;
                CashRegisterDataService.openCashRegisterClosed(cashRegisterId)
                .then( response => {
                    this.$swal.fire({ title: 'Caja abierta', text: 'Caja abierta exitosamente', icon: 'success', showConfirmButton: false, timer: 2000 })
                    this.initTableCashRegister();
                }).catch( error => {
                    this.$swal.fire({ title: 'Error', text: 'No se pudo procesar la petición, ' + error?.response?.data, icon: 'error', showConfirmButton: false, timer: 2000 })
                })
            }).catch( err => {
                this.$swal.fire({ title: 'Error', text: 'No se pudo procesar la petición, ' +err, icon: 'error', showConfirmButton: false, timer: 2000 })
            });
        },
        closeCashRegister({ cashRegisterId }){
            this.$swal.fire({
                title: 'Estas seguro de cerrar la caja?',
                text: "Si cierra la caja no se podrá revertir la acción!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No, Cancelar!',
                confirmButtonText: 'Si, cerrar!'
            }).then( result => {
                if( !result.isConfirmed ) return;                
                CashRegisterDataService.closeCashRegisterAdmin(cashRegisterId).then( _ => {
                    this.$swal.fire({ title: 'Caja cerrada', text: 'Caja cerrada exitosamente', icon: 'success', showConfirmButton: false, timer: 2000 })
                    this.initTableCashRegister();
                }).catch( error => {
                    this.$swal.fire({ title: 'Error', text: 'No se pudo procesar la petición: ' +error?.response?.data, icon: 'error', showConfirmButton: false, timer: 2000 })
                })
            }).catch( err => {
                this.$swal.fire({ title: 'Error', text: 'No se pudo procesar la petición, ' +err, icon: 'error', showConfirmButton: false, timer: 2000 })
            } );
        },
        handlePdfModal(){
            this.showPdf = !this.showPdf
            this.cleanupPdf()
        },
        cleanupPdf(){
            if(this.pdfSource){
                URL.revokeObjectURL(this.pdfSource)
                this.pdfSource = null
            }
            this.pdfBlob = null
        },
        checkUserCashRegister(cashRegisterId) {
            return cashRegisterId === this.currentUser.id;
        },
        shouldShowCashRegister(item) {
            if (item.status !== 'OPENED') return false;
            return this.isAdmin || this.checkUserCashRegister(item.id);
        }
    },
    computed: {
        isAdmin(){ return UsuarioDataService.getUserRoles().includes('ROLE_ADMIN'); },
    }
}
</script>